import { render, staticRenderFns } from "./WorkRoles.vue?vue&type=template&id=32f184c5&scoped=true&"
import script from "./WorkRoles.vue?vue&type=script&lang=js&"
export * from "./WorkRoles.vue?vue&type=script&lang=js&"
import style0 from "./WorkRoles.vue?vue&type=style&index=0&id=32f184c5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f184c5",
  null
  
)

export default component.exports